/*!
 * lightbox.js v1.0.1
 * Author: Oleg Kuznetsov
 * Author URL: https://designbyoleg.com
 * Description: Lightbox component
 * License: MIT
 */
(function ($) {
    const defaultOptions = {
        id: 'lightbox',
        closeButton: true,
        closeSelectors: '',
        closeOnBackdrop: true,
        closeOnEsc: true,
        closeOnSwipe: true,
        lockScroll: true,
        clearOnClose: true
    };

    let instance = null;

    class Lightbox {
        constructor($el, options) {
            this.$el = $el;
            this.options = { ...defaultOptions, ...options };
            this.$content = this.$el.find('.lightbox-content');
            this.bindEvents();
        }

        bindEvents() {
            this.$el.off('.lightbox').on('click.lightbox', (e) => {
                e.preventDefault();
                const $target = $(e.target);
                if (
                    (this.options.closeButton && $target.closest('.lightbox-close').length) ||
                    (this.options.closeOnBackdrop && $target.hasClass('lightbox-background')) ||
                    (this.options.closeSelectors && $target.closest(this.options.closeSelectors).length)
                ) {
                    this.close();
                }
            });

            /**
             * There's issue with excape.
             * If we have a manually created lightbox
             * And then create dynamic one (or vice versa),
             * only the latest one gets the Excape.
             */
            $(document).off('keydown.lightbox').on('keydown.lightbox', (e) => {
                if (this.options.closeOnEsc && e.key === 'Escape') {
                    this.close();
                }
            });

            // Optional swipe to close for touch devices
            if (this.options.closeOnSwipe) {
                let startX = 0;
                this.$el.off('touchstart.lightbox').on('touchstart.lightbox', (e) => {
                    startX = e.originalEvent.touches[0].clientX;
                });
                this.$el.off('touchend.lightbox').on('touchend.lightbox', (e) => {
                    const endX = e.originalEvent.changedTouches[0].clientX;
                    if (Math.abs(endX - startX) > 100) {
                        this.close();
                    }
                });
            }
        }

        trapFocus() {
            const focusableElements = this.$el.find('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
            // console.log(focusableElements);
            const firstFocusable = focusableElements.first();
            const lastFocusable = focusableElements.last();
        
            this.$el.on('keydown.lightbox-focus', function (e) {
                // Trap TAB (forward) and Shift+TAB (backward)
                if (e.key === 'Tab') {
                    if (e.shiftKey) {
                        // Shift+Tab: If focus is on the first, move to the last
                        if (document.activeElement === firstFocusable[0]) {
                            lastFocusable.focus();
                            e.preventDefault();
                        }
                    } else {
                        // Tab: If focus is on the last, move to the first
                        if (document.activeElement === lastFocusable[0]) {
                            firstFocusable.focus();
                            e.preventDefault();
                        }
                    }
                }
            });
        
            // Focus the first element when the lightbox is opened
            firstFocusable.focus();
        }

        open(content, customOptions = {}) {
            this.options = { ...this.options, ...customOptions };
            // if (this.options.clearOnClose) this.$content.empty();
            this.$content.append(content);

            if (this.options.lockScroll) {
                $('body').css('overflow', 'hidden');
            }

            this.$el.addClass('is-active').attr('aria-hidden', 'false');

            if (this.options.closeButton) {
                this.$el.find('.lightbox-close').show();
            } else {
                this.$el.find('.lightbox-close').hide();
            }

            /* Run a funciton when lightbox opens */
            if (typeof this.options.onOpen === 'function') {
                this.options.onOpen(this.$el);
            }

            this.$el.trigger('lightbox:open');
            this.$el.focus();

            /* Trap focus inside the lightbox when opened */
            this.trapFocus();
        }

        close() {
            if (this.options.clearOnClose) {
                this.$content.empty();
            }

            this.$el.removeClass('is-active').attr('aria-hidden', 'true');
            $('body').css('overflow', '');

            this.$el.trigger('lightbox:close');

            this.$el.off('keydown.lightbox-focus');
        }
    }

    // Singleton
    $.lightbox = {
        init: function (options = {}) {
            if (!instance) {
                const id = options.id || defaultOptions.id;
                const $existing = $(`[data-lightbox-id="${id}"]`);
                let $el;

                if ($existing.length) {
                    $el = $existing;
                } else {
                    $el = $(`
                        <div class="lightbox" data-lightbox-id="${id}" tabindex="-1" role="dialog" aria-modal="true" aria-hidden="true">
                            <div class="lightbox-background"></div>
                            <div class="lightbox-content" role="document" style="width:100%;"></div>
                            <button class="lightbox-close" aria-label="Close">
                                <span></span>
                                <svg width="242" height="242" viewBox="0 0 242 242" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <path id="icon-cross" fill="#000000" fill-rule="evenodd" stroke="none" d="M 14.934425 241.20816 L 0.791847 227.065582 L 106.858253 121.001122 L 0.791847 14.934723 L 14.934425 0.792145 L 120.998878 106.856598 L 227.065277 0.792145 L 241.207855 14.934723 L 135.143402 121.001122 L 241.207855 227.065582 L 227.065277 241.20816 L 120.998878 135.141754 L 14.934425 241.20816 Z"/>
                                </svg>
                            </button>
                        </div>
                    `).appendTo('body');
                }

                instance = new Lightbox($el, options);
            }

            return instance;
        }
    };

    // Element-specific lightbox
    $.fn.lightbox = function (options = {}) {
        return new Lightbox(this.first(), options);
    };
})(jQuery);